export const PROMOTIONS_SET_PROMOS = 'PROMOTIONS_SET_PROMOS';
export const SHOW_PROMOTION = 'SHOW_PROMOTION';
export const SHOW_LOADER = 'SHOW_PROMOTIONS_LOADER';
